import { getInstance } from './instance';

const instance = getInstance();

export const getOnboardingCompletionStatus = (email: string) => {
  const url = `/onboard/onboarding-completion/status?email=${email}`;
  return instance.get(url);
};

export const createOnboardingCompletion = (email: string) => {
  const url = `/onboard/onboarding-completion/create?email=${email}`;
  return instance.get(url);
};
